/**
 * Equipment Status Overview page - Displays comprehensive dashboard for monitoring equipment status.
 */

import React from 'react';
import { useParams, useLocation, useSearchParams } from 'react-router-dom';
import { EquipmentStatusContent } from '../components/equipment-status/equipment-status-content';
import { ResponsiveLayout } from '../components/equipment-status/responsive-layout';
import Column from '@amzn/meridian/column';
import Text from '@amzn/meridian/text';
import Alert from '@amzn/meridian/alert';
import { validateEquipmentParams, parseQueryParams } from '../services/navigation';

export const EquipmentStatusOverview = () => {
    const [searchParams] = useSearchParams();
    // const { site, encodedApmId } = useParams<{ site: string; encodedApmId: string }>();
    // const location = useLocation();

    // Decode the APM ID from the URL
    // const apmId = encodedApmId ? decodeURIComponent(encodedApmId) : undefined;
    const encodedSite = searchParams.get('site');
    const encodedAsset = searchParams.get('asset');
    const encodedNodeId = searchParams.get('nodeId');
    const site = encodedSite ? decodeURIComponent(encodedSite) : undefined;
    const apmId = encodedAsset ? decodeURIComponent(encodedAsset) : undefined;
    const selectedNodeId = encodedNodeId ? decodeURIComponent(encodedNodeId) : undefined;

    // Parse query parameters (for nodeId)
    // const queryParams = parseQueryParams(location.search);
    // const selectedNodeId = queryParams.nodeId;

    // Validate URL parameters
    const validation = validateEquipmentParams(site, apmId);

    // if (!validation.isValid) {
    //     return (
    //         <ResponsiveLayout title="Equipment Status Overview - Invalid Parameters">                
    //             <Alert type="error">
    //                 {validation.errorMessage || 'Both site and asset parameters are required to view equipment status.'}
    //                 Please, navigate to a valid URL with both site and asset parameters.
    //             </Alert>
    //         </ResponsiveLayout>
    //     );
    // }

    return <EquipmentStatusContent
        site={site!}
        apmId={apmId!}
        selectedNodeId={selectedNodeId}
    />;
};